import type { IMediaFolder } from '../../../models/press/media-folder.model';

export class MediaFolderApiModel {
  public static mapToBusinessModel(apiModel: MediaFolderApiModel): IMediaFolder | undefined {
    if (!apiModel) {
      return undefined;
    }
    return {
      id: apiModel.id,
      name: apiModel.name,
    };
  }

  public id!: number;
  public name!: string;
}
